import React, { useEffect, useMemo, useRef, useState } from "react";
import './advogado.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faEyeSlash,
  faUser,
  faIdCard,
  faLocationDot,
  faAddressCard,
  faEnvelope,
  faPhone,
  faLock,
  faCamera,
  faCircleCheck,
  faTriangleExclamation,
  faScaleBalanced,
  faArrowLeft,
  // faCircleInfo, // OAB DESATIVADA TEMPORARIAMENTE (2026-09-03) - usado so no box de situacao da OAB
} from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import Banner from '../../assets/bannerADV.png';
import Logo from '../../assets/brasao_sejus.png';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from "../../services/api";
import FormattedInput from '../../components/FormatdInput/formatFunctions';
import useSubmitLock from '../../utils/useSubmitLock';
import { TYPE_OAB_OPTIONS, resolveTypeOab } from '../../utils/typeOab';

const MAX_PHOTO_SIZE_MB = 5;

// ============================================================================
// OAB DESATIVADA TEMPORARIAMENTE (2026-09-03)
// A consulta automatica da situacao da OAB foi comentada porque o endpoint do
// back  EXIGE token JWT e
// esta e uma tela publica (cadastro sem login). Sem token o back retorna 401 e
// liberar essa consulta sem auth por enquanto.
// Enquanto isso o cadastro segue SEM validacao / preenchimento automatico da OAB
// (nome, CPF e email passam a ser digitados manualmente).
// PARA REATIVAR: back precisa expor a consulta para a tela publica (ou fluxo com
// token) e ai descomentar, nesta ordem: (1) este helper resolveOabStatusVariant,
// (2) o state `oabLookup`, (3) o useEffect da consulta da OAB, (4) o bloco de
// JSX com os hints de situacao da OAB.
// ============================================================================
// const resolveOabStatusVariant = (situacao) => {
//   const normalized = String(situacao || '')
//     .normalize('NFD')
//     .replace(/[̀-ͯ]/g, '')
//     .trim()
//     .toUpperCase();
//   if (normalized.includes('REGULAR')) return 'regular';
//   if (normalized.includes('CANCELAD')) return 'cancelado';
//   if (normalized.includes('FALECID')) return 'falecido';
//   return 'outro';
// };

const buildInitialFormData = () => ({
  name: '',
  surname: '',
  oab: '',
  uf_oab: '',
  type_oab: '',
  cpf: '',
  email: '',
  phone: '',
  password: '',
  confirmarSenha: '',
});

function FormField({ label, htmlFor, icon, error, children }) {
  return (
    <div className={`advreg-field${error ? ' advreg-field-error' : ''}`}>
      <label htmlFor={htmlFor}>{label}</label>
      <div className="advreg-input-wrap">
        <FontAwesomeIcon icon={icon} className="advreg-input-icon" />
        {children}
      </div>
      {error && (
        <span className="advreg-error">
          <FontAwesomeIcon icon={faTriangleExclamation} /> {error}
        </span>
      )}
    </div>
  );
}

function CadastroAdvogado() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const [formData, setFormData] = useState(buildInitialFormData());
  const [errors, setErrors] = useState({});
  const [foto, setFoto] = useState(null);
  const [fotoPreview, setFotoPreview] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // OAB DESATIVADA TEMPORARIAMENTE (2026-09-03) - ver comentario no topo do arquivo.
  // const [oabLookup, setOabLookup] = useState({ status: 'idle', info: null });

  useEffect(() => {
    if (!foto) {
      setFotoPreview(null);
      return;
    }
    const objectUrl = URL.createObjectURL(foto);
    setFotoPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [foto]);

  // ==========================================================================
  // OAB DESATIVADA TEMPORARIAMENTE (2026-09-03)
  // Consulta automatica da situacao da OAB (numero + UF). Comentada porque o
  // endpoint exige token JWT e esta tela e publica -> 401 -> redirect p/ /login.
  // Ver comentario detalhado no topo do arquivo. Reativar quando o back liberar.
  // ==========================================================================
  // useEffect(() => {
  //   const registration = formData.oab.trim();
  //   const uf = formData.uf_oab.trim();
  //
  //   if (!registration || uf.length !== 2) {
  //     setOabLookup({ status: 'idle', info: null });
  //     return;
  //   }
  //
  //   let cancelled = false;
  //   setOabLookup((prev) => ({ ...prev, status: 'loading' }));
  //
  //   const timer = setTimeout(async () => {
  //     try {
  //       const response = await api.get('/internals/visitor/oab/integration/lawyer/consult/', {
  //         params: { registration, uf },
  //       });
  //       if (cancelled) return;
  //
  //       const result = response.data;
  //       const inscricoes = result?.data?.inscricoes;
  //       const match = Array.isArray(inscricoes)
  //         ? inscricoes.find((item) => String(item?.uf || '').toUpperCase() === uf) || inscricoes[0]
  //         : null;
  //
  //       if (result?.success && match) {
  //         setOabLookup({
  //           status: 'found',
  //           info: {
  //             situacao: match.situacao || '',
  //             tipo: match.tipo || '',
  //             uf: match.uf || uf,
  //             numero: match.numero || registration,
  //           },
  //         });
  //
  //         setFormData((prev) => {
  //           const updated = { ...prev };
  //           if (result.data.nome) {
  //             const parts = String(result.data.nome).trim().split(/\s+/);
  //             updated.name = parts[0] || '';
  //             updated.surname = parts.length > 1 ? parts.slice(1).join(' ') : '';
  //           }
  //           if (result.data.cpf) {
  //             const cpfDigits = String(result.data.cpf).replace(/\D/g, '').slice(0, 11);
  //             updated.cpf = cpfDigits
  //               .replace(/(\d{3})(\d)/, '$1.$2')
  //               .replace(/(\d{3})(\d)/, '$1.$2')
  //               .replace(/(\d{3})(\d{1,2})/, '$1-$2');
  //           }
  //           if (match.email) {
  //             updated.email = match.email;
  //           }
  //           return updated;
  //         });
  //       } else {
  //         setOabLookup({ status: 'not_found', info: null });
  //       }
  //     } catch (error) {
  //       if (!cancelled) {
  //         console.error('Erro ao consultar situação da OAB:', error);
  //         setOabLookup({ status: 'not_found', info: null });
  //       }
  //     }
  //   }, 600);
  //
  //   return () => {
  //     cancelled = true;
  //     clearTimeout(timer);
  //   };
  // }, [formData.oab, formData.uf_oab]);

  const passwordStrength = useMemo(() => {
    const value = formData.password;
    if (!value) return 0;
    let score = 0;
    if (value.length >= 6) score++;
    if (value.length >= 10) score++;
    if (/[a-z]/.test(value) && /[A-Z]/.test(value)) score++;
    if (/\d/.test(value)) score++;
    if (/[^A-Za-z0-9]/.test(value)) score++;
    return Math.min(score, 4);
  }, [formData.password]);

  const strengthLabel = ['Muito fraca', 'Fraca', 'Média', 'Boa', 'Forte'][passwordStrength];

  const clearFieldError = (name) => {
    setErrors((prev) => (prev[name] ? { ...prev, [name]: undefined } : prev));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let nextValue = value;
    if (name === 'uf_oab') {
      nextValue = value.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2);
    }
    setFormData((prev) => ({ ...prev, [name]: nextValue }));
    clearFieldError(name);
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      setErrors((prev) => ({ ...prev, foto: 'Envie um arquivo de imagem válido.' }));
      return;
    }
    if (file.size > MAX_PHOTO_SIZE_MB * 1024 * 1024) {
      setErrors((prev) => ({ ...prev, foto: `A imagem deve ter no máximo ${MAX_PHOTO_SIZE_MB}MB.` }));
      return;
    }

    setFoto(file);
    clearFieldError('foto');
  };

  const clearFields = () => {
    setFormData(buildInitialFormData());
    setFoto(null);
    setErrors({});
    setShowPassword(false);
    setShowConfirmPassword(false);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const validateForm = () => {
    const validationErrors = {};

    if (!formData.name.trim()) validationErrors.name = 'Nome é obrigatório.';
    if (!formData.surname.trim()) validationErrors.surname = 'Sobrenome é obrigatório.';
    if (!formData.oab.trim()) validationErrors.oab = 'Número da OAB é obrigatório.';

    if (!formData.uf_oab.trim()) {
      validationErrors.uf_oab = 'UF é obrigatória.';
    } else if (formData.uf_oab.trim().length !== 2) {
      validationErrors.uf_oab = 'Informe a sigla da UF.';
    }

    if (!resolveTypeOab(formData.type_oab)) {
      validationErrors.type_oab = 'Tipo de inscrição é obrigatório.';
    }

    const cpfDigits = formData.cpf.replace(/\D/g, '');
    if (!cpfDigits) {
      validationErrors.cpf = 'CPF é obrigatório.';
    } else if (cpfDigits.length !== 11) {
      validationErrors.cpf = 'CPF incompleto.';
    }

    if (!formData.email.trim()) {
      validationErrors.email = 'Email é obrigatório.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      validationErrors.email = 'Informe um email válido.';
    }

    const phoneDigits = formData.phone.replace(/\D/g, '');
    if (!phoneDigits) {
      validationErrors.phone = 'Telefone é obrigatório.';
    } else if (phoneDigits.length < 10) {
      validationErrors.phone = 'Telefone incompleto.';
    }

    if (!formData.password) {
      validationErrors.password = 'Senha é obrigatória.';
    } else if (formData.password.length < 6) {
      validationErrors.password = 'A senha deve ter pelo menos 6 caracteres.';
    }

    if (!formData.confirmarSenha) {
      validationErrors.confirmarSenha = 'Confirme a senha.';
    } else if (formData.password !== formData.confirmarSenha) {
      validationErrors.confirmarSenha = 'As senhas não coincidem.';
    }

    if (!foto) {
      validationErrors.foto = 'Envie uma foto 3x4.';
    }

    return validationErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('Verifique os campos destacados.');
      return;
    }

    await runWithSubmitLock(async () => {
      const data = new FormData();
      data.append('name', formData.name);
      data.append('surname', formData.surname);
      data.append('oab', formData.oab);
      data.append('uf_oab', formData.uf_oab);
      data.append('type_oab', formData.type_oab);
      data.append('email', formData.email);
      data.append('password', formData.password);
      data.append('cpf', formData.cpf);
      data.append('phone', formData.phone);
      data.append('Foto 3X4', foto);

      try {
        await api.post('internals/visitor/lawyer/', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        toast.success('Cadastro realizado com sucesso!');
        clearFields();
        navigate('/login');
      } catch (error) {
        console.error('Erro ao cadastrar advogado:', error?.response || error);
        const errorData = error?.response?.data;
        const baseMessage = errorData?.message;
        // Erros de validação de OAB trazem um detalhe extra em oab_response.
        const oabDetail = typeof errorData?.oab_response?.message === 'string' ? errorData.oab_response.message : '';
        const apiMessage = oabDetail && baseMessage && oabDetail !== baseMessage
          ? `${baseMessage} ${oabDetail}`
          : (oabDetail || baseMessage);
        toast.error(apiMessage || 'Erro! Verifique os dados.');
      }
    });
  };

  return (
    <div className="advreg-page">
      <div className="advreg-hero">
        <div className="advreg-hero-content">
          <img src={Logo} alt="SEJUS" className="advreg-hero-logo" />
          <span className="advreg-hero-badge">
            <FontAwesomeIcon icon={faScaleBalanced} /> Área do Advogado
          </span>
          <h1>Solicite seu acesso ao SIGEPEN</h1>
          <p>
            Se você ja fez visita em um unidade prisional depois do novo sistema, provavelmente já tenha acesso.
          </p>
          <ul className="advreg-hero-list">
            <li><FontAwesomeIcon icon={faCircleCheck} /> Agendamento de visitas online</li>
            <li><FontAwesomeIcon icon={faCircleCheck} /> Acompanhamento dos seus atendimentos</li>
          </ul>
          <img src={Banner} alt="" className="advreg-hero-illustration" />
        </div>
      </div>

      <div className="advreg-form-side">
        <div className="advreg-card">
          <Link to="/login" className="advreg-back">
            <FontAwesomeIcon icon={faArrowLeft} /> Voltar para login
          </Link>

          <div className="advreg-card-header">
            <h2>Cadastro de Advogado</h2>
            <p>Preencha os dados abaixo para criar sua conta.</p>
          </div>

          <form onSubmit={handleSubmit} noValidate className="advreg-form">
            <div className="advreg-section">
              <h3 className="advreg-section-title">Dados profissionais</h3>
              <div className="advreg-row advreg-row-uf">
                <FormField label="Número da OAB" htmlFor="adv-oab" icon={faIdCard} error={errors.oab}>
                  <input
                    id="adv-oab"
                    type="text"
                    name="oab"
                    placeholder="Número da OAB"
                    value={formData.oab}
                    onChange={handleChange}
                  />
                </FormField>
                <FormField label="UF" htmlFor="adv-uf-oab" icon={faLocationDot} error={errors.uf_oab}>
                  <input
                    id="adv-uf-oab"
                    type="text"
                    name="uf_oab"
                    placeholder="UF"
                    maxLength={2}
                    value={formData.uf_oab}
                    onChange={handleChange}
                  />
                </FormField>
              </div>
              <div className="advreg-row advreg-row-full">
                <FormField label="Tipo de inscrição" htmlFor="adv-type-oab" icon={faScaleBalanced} error={errors.type_oab}>
                  <select
                    id="adv-type-oab"
                    name="type_oab"
                    value={formData.type_oab}
                    onChange={handleChange}
                  >
                    <option value="">Selecione o tipo de inscrição</option>
                    {TYPE_OAB_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </FormField>
              </div>

              {/* OAB DESATIVADA TEMPORARIAMENTE (2026-09-03) - hints da situacao da
                  OAB. Comentado junto com o useEffect da consulta (ver topo do
                  arquivo). Reativar quando o back liberar a consulta sem token.
              {oabLookup.status === 'loading' && (
                <p className="advreg-oab-hint advreg-oab-hint-loading">
                  <span className="advreg-oab-spinner" /> Consultando situação da OAB...
                </p>
              )}
              {oabLookup.status === 'not_found' && (
                <p className="advreg-oab-hint">Não foi possível localizar essa inscrição na OAB.</p>
              )}
              {oabLookup.status === 'found' && oabLookup.info && (
                <div className={`advreg-oab-box advreg-oab-status-${resolveOabStatusVariant(oabLookup.info.situacao)}`}>
                  <FontAwesomeIcon icon={faCircleInfo} className="advreg-oab-box-icon" />
                  <div>
                    <strong>Situação da OAB: {oabLookup.info.situacao || 'Não informada'}</strong>
                    <span>{[oabLookup.info.tipo, `OAB/${oabLookup.info.uf} ${oabLookup.info.numero}`].filter(Boolean).join(' - ')}</span>
                  </div>
                </div>
              )}
              */}
            </div>

            <div className="advreg-section">
              <h3 className="advreg-section-title">Dados pessoais</h3>
              <div className="advreg-row">
                <FormField label="Nome" htmlFor="adv-name" icon={faUser} error={errors.name}>
                  <input
                    id="adv-name"
                    type="text"
                    name="name"
                    placeholder="Nome"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </FormField>
                <FormField label="Sobrenome" htmlFor="adv-surname" icon={faUser} error={errors.surname}>
                  <input
                    id="adv-surname"
                    type="text"
                    name="surname"
                    placeholder="Sobrenome"
                    value={formData.surname}
                    onChange={handleChange}
                  />
                </FormField>
              </div>
            </div>

            <div className="advreg-section">
              <h3 className="advreg-section-title">Documento e contato</h3>
              <FormField label="CPF" htmlFor="adv-cpf" icon={faAddressCard} error={errors.cpf}>
                <FormattedInput id="adv-cpf" type="cpf" name="cpf" value={formData.cpf} onChange={handleChange} />
              </FormField>
              <div className="advreg-row">
                <FormField label="Email" htmlFor="adv-email" icon={faEnvelope} error={errors.email}>
                  <input
                    id="adv-email"
                    type="email"
                    name="email"
                    placeholder="seuemail@exemplo.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </FormField>
                <FormField label="Telefone" htmlFor="adv-phone" icon={faPhone} error={errors.phone}>
                  <FormattedInput id="adv-phone" type="telefone" name="phone" value={formData.phone} onChange={handleChange} />
                </FormField>
              </div>
            </div>

            <div className="advreg-section">
              <h3 className="advreg-section-title">Segurança</h3>
              <div className="advreg-row">
                <div className={`advreg-field${errors.password ? ' advreg-field-error' : ''}`}>
                  <label htmlFor="adv-password">Senha</label>
                  <div className="advreg-input-wrap advreg-password-wrap">
                    <FontAwesomeIcon icon={faLock} className="advreg-input-icon" />
                    <input
                      id="adv-password"
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      placeholder="Crie uma senha"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <button
                      type="button"
                      className="advreg-eye-btn"
                      onClick={() => setShowPassword((prev) => !prev)}
                      aria-label="Mostrar ou ocultar senha"
                    >
                      <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                    </button>
                  </div>
                  {formData.password && (
                    <div className="advreg-strength">
                      <div className="advreg-strength-bars">
                        {[1, 2, 3, 4].map((step) => (
                          <span
                            key={step}
                            className={step <= passwordStrength ? `filled-${passwordStrength}` : ''}
                          />
                        ))}
                      </div>
                      <span className="advreg-strength-label">{strengthLabel}</span>
                    </div>
                  )}
                  {errors.password && (
                    <span className="advreg-error">
                      <FontAwesomeIcon icon={faTriangleExclamation} /> {errors.password}
                    </span>
                  )}
                </div>

                <div className={`advreg-field${errors.confirmarSenha ? ' advreg-field-error' : ''}`}>
                  <label htmlFor="adv-confirm-password">Confirmar senha</label>
                  <div className="advreg-input-wrap advreg-password-wrap">
                    <FontAwesomeIcon icon={faLock} className="advreg-input-icon" />
                    <input
                      id="adv-confirm-password"
                      type={showConfirmPassword ? 'text' : 'password'}
                      name="confirmarSenha"
                      placeholder="Repita a senha"
                      value={formData.confirmarSenha}
                      onChange={handleChange}
                    />
                    <button
                      type="button"
                      className="advreg-eye-btn"
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                      aria-label="Mostrar ou ocultar senha"
                    >
                      <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                    </button>
                  </div>
                  {errors.confirmarSenha && (
                    <span className="advreg-error">
                      <FontAwesomeIcon icon={faTriangleExclamation} /> {errors.confirmarSenha}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="advreg-section">
              <h3 className="advreg-section-title">Foto</h3>
              <label className={`advreg-upload${errors.foto ? ' has-error' : ''}`} htmlFor="adv-foto">
                <div className="advreg-upload-preview">
                  {fotoPreview ? (
                    <img src={fotoPreview} alt="Pré-visualização da foto" />
                  ) : (
                    <FontAwesomeIcon icon={faCamera} />
                  )}
                </div>
                <div className="advreg-upload-text">
                  <strong>{foto ? foto.name : 'Selecione sua foto'}</strong>
                  <span>PNG ou JPG, até {MAX_PHOTO_SIZE_MB}MB</span>
                </div>
                <input
                  id="adv-foto"
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </label>
              {errors.foto && (
                <span className="advreg-error">
                  <FontAwesomeIcon icon={faTriangleExclamation} /> {errors.foto}
                </span>
              )}
            </div>

            <button type="submit" className="advreg-submit-btn" disabled={isSubmitting}>
              {isSubmitting ? (
                <span className="advreg-btn-loading">
                  <span className="advreg-spinner" /> Cadastrando...
                </span>
              ) : (
                'Criar minha conta'
              )}
            </button>

            <p className="advreg-login-link">
              Já possui uma conta? <Link to="/login">Fazer login</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CadastroAdvogado;
